/**
 * Die Fusszeile. Steht auf jeder Seite.
 *
 * Zwei Dinge gehoeren dort hin und nirgendwo anders: wer das Spiel macht,
 * und die Pflichtangaben. Datenschutz und Impressum sind nicht
 * Ausstattung, sondern Voraussetzung dafuer, dass auf dieser Seite nach
 * einer Mailadresse gefragt werden darf (Kapitel 15).
 */
import { Link } from 'react-router-dom'

import { useLang } from '../lang'

export function Footer() {
  const { lang, switchTo } = useLang()
  const de = lang === 'de'
  return (
    <footer className="foot">
      <div className="foot__by">
        <span>{de ? 'Ein Spiel von' : 'A game by'}</span>
        <a href={`https://cics.ch/${de ? 'de' : 'en'}/`} target="_blank" rel="noopener">
          <b>CICS</b>
        </a>
        <span>{de ? 'und' : 'and'}</span>
        <b>ZweiOnCTI</b>
      </div>
      <div className="foot__links">
        <Link to="/regeln">{de ? 'Regeln' : 'Rules'}</Link>
        <Link to="/wand">{de ? 'Wand der Schafe' : 'Wall of Sheep'}</Link>
        <Link to="/datenschutz">{de ? 'Datenschutz' : 'Privacy'}</Link>
        <Link to="/impressum">{de ? 'Impressum' : 'Imprint'}</Link>
      </div>
      {/* Die Sprachwahl gehoert auf jede Seite, nicht in ein Konto, das
          man erst anlegen muss. Darum hier, wo die Fusszeile ohnehin steht. */}
      <div className="foot__lang" role="group" aria-label={de ? 'Sprache' : 'Language'}>
        <button
          type="button"
          className={`langknopf${de ? ' langknopf--an' : ''}`}
          aria-pressed={de}
          onClick={() => switchTo('de')}
        >
          DE
        </button>
        <span aria-hidden="true">·</span>
        <button
          type="button"
          className={`langknopf${!de ? ' langknopf--an' : ''}`}
          aria-pressed={!de}
          onClick={() => switchTo('en')}
        >
          EN
        </button>
      </div>
    </footer>
  )
}
